import React, {useContext, useState} from "react";
import {Modal, Platform, ScrollView, View} from "react-native";
import MainStyle from "../../MainStyle";
import Button from "../components/Button";
import {colors} from "../assets/styles/colors";
import Select from "../components/Select";
import {StoreContext} from "../components/StoreContextProvider";
import ServiceClient from "../utils/ServiceClient";
import {useNavigation} from "@react-navigation/native";
import Div from "../lib/Div";
import P from "../lib/P";
import {StartingPage} from "../constants";

const items = [
  {value: '0', label: '6 months'}, {value: '1', label: '1 year'}, {value: '2', label: '2 years'},
  {value: '3', label: 'Forever'}
];

type Props = { visible: boolean, onClose: () => void };

const SelfLimitationModal = (props: Props) => {
  const {visible} = props;
  const [value, setValue] = useState('0');
  const Context = useContext(StoreContext);
  const {cancelModalConfig} = Context;
  const navigation: any = useNavigation();
  const [isLoading, setIsLoading] = useState(false);

  const confirmSelfLimitation = () => {
    setIsLoading(true);

    ServiceClient.enableSelfLimitation(+value).then(() => {
      setIsLoading(false);
      props.onClose();

      Context.setCancelModalConfig({
        visible: true, title: 'Success', titleColor: MainStyle.c_green, leftBtnText: 'OK',
        subtitle: 'You have successfully confirmed your Self-Limitation.',
        onExit: () => {
          Context.setCancelModalConfig({...cancelModalConfig, visible: false});
          Context.setLoadingOverlay(true);

          Context.getUser().then(() => {
            Context.setLoadingOverlay(false);
            navigation.navigate('challenges');

          }).catch(err => {
            console.log('getUser err', err);
            Context.logout().then(() => {
              setTimeout(() => {
                if (Platform.OS === 'web') window.location.reload();
              }, 150);
              navigation.reset({index: 0, routes: [{name: StartingPage}]});
              Context.setLoadingOverlay(false);
            });
          });
        }
      });

    }).catch(err => {
      console.log('enableSelfLimitation err', err);
      setIsLoading(false);

      Context.setCancelModalConfig({
        visible: true, title: 'Error', subtitle: err.message, rightBtnText: 'OK',
        onResume: () => {
          Context.setCancelModalConfig({...cancelModalConfig, visible: false});
        }
      });
    })
  };

  return (
    <Modal animationType="fade" transparent visible={visible} statusBarTranslucent={false}
           hardwareAccelerated={false} onRequestClose={props.onClose}>
      <View style={styles.wrap}>
        <ScrollView contentContainerStyle={[MainStyle.full_h, MainStyle.full_w, MainStyle.a_i_c, MainStyle.j_c_c]}>
          <Div w={300} bg={colors.bottomTabBg} borderWidth={1} borderColor={colors.popupBorder} rounded={4} pt={25}
               px={30} mb={101}>
            <P color={colors.lightBlue} fw="600" fs={20} ta="center" mb={20}>SELF LIMITATION</P>

            <Select
              value={value} onChangeText={(val) => setValue(val)} label="TIMEFRAME"
              customItems={items} mb={38} popupTitle="Select Timeframe"
            />
          </Div>

          <Button
            text="CONFIRM SELF LIMITATION" h={40} fontSize={16} bg={colors.unselect} w={240} mb={15}
            onPress={confirmSelfLimitation} isLoading={isLoading}
          />

          <Button
            text="CANCEL" h={40} fontSize={16} bg="transparent" w={240} borderColor={colors.popupDangerPrimary}
            borderWidth={1} color={colors.popupDangerPrimary} onPress={isLoading ? undefined : props.onClose}
          />
        </ScrollView>
      </View>
    </Modal>
  );
};

const styles = {
  wrap: [MainStyle.full_h, MainStyle.full_w, MainStyle.bc_modalBg, MainStyle.fix_gradient_and_modal_error_in_landscape]
};

export default React.memo(SelfLimitationModal);
